import React from 'react'
import FaqPage from '../components/FaqPage/faq-page'
import {getLocalization} from '../localization'


class FaqPageEn extends React.Component {
  render() {
    const {globalLocalization, faqLocalization} = this.props.data
    const localization = getLocalization([globalLocalization, faqLocalization], 'en-US')

    return (
      <FaqPage content={ this.props.data.contentfulPage } localization={ localization } lang='en'/>
    )
  }
}

export default FaqPageEn

export const query = graphql`
query FaqPageQueryEn {
  globalLocalization: allContentfulLocalizationString(filter: {key: {regex: "/^global/" }, node_locale: {eq: "en-US"}}) {
    edges {
      node { 
        key
        text
        node_locale
      }
    }
  }

  faqLocalization: allContentfulLocalizationString(filter: {key: {regex: "/^faq/" }, node_locale: {eq: "en-US"}}) {
    edges {
      node { 
        key
        text
        node_locale
      }
    }
  }

  contentfulPage: contentfulPage(title: {eq: "FAQ"}, node_locale: {eq: "en-US"}) {
    node_locale
    title
    id
    ...HeroFragment
    ...PageFragment
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/faq.en.js